<template>
  <div class="flow-script-set">
  <mw-dialog ref="dialog" :size="size" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="close">
    <el-form :model="form" label-width="110px" ref="secrecordForm" style="padding-top:20px;">
      <!--<el-row>
        <el-col :span="10">
          <el-form-item label="表单创建前置：" v-show="type=='process'">
            <el-input  v-model="form.form_create_preName"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.form_create_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('form_create_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.form_create_postName"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.form_create_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('form_create_post')" v-show="type=='process'">选择</el-button>
        </el-col>
      </el-row>-->
      <el-row>
        <el-col :span="10">
          <el-form-item label="表单保存前置：" v-show="type=='process'">
            <el-input  v-model="form.form_save_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.form_save_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('form_save_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.form_save_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.form_save_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('form_save_post')" v-show="type=='process'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程启动前置：" v-show="type=='process'">
            <el-input  v-model="form.process_start_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_start_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_start_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.process_start_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_start_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_start_post')" v-show="type=='process'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="21">
          <el-form-item label="流程启动拦截：" v-show="false">
            <el-input  v-model="form.process_start_interceptName"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_start_interceptAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="showFlowScript('process_start_intercept')" v-show="false">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程办结前置：" v-show="type=='process'">
            <el-input v-model="form.process_done_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_done_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_done_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input v-model="form.process_done_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_done_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_done_post')" v-show="type=='process'">选择</el-button>
          <el-tooltip placement="top" style="width:10%" v-show="type=='process'">
            <div slot="content">
              流程办结上下文参数：<br/>
                  isFlowOver：是否流程办结 true-是 false-否<br/>
                  isDocOver： 是否文档办结 true-是 false-否<br/>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程挂起前置：" v-show="type=='process'">
            <el-input  v-model="form.process_suspend_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_suspend_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_suspend_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.process_suspend_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_suspend_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_suspend_post')" v-show="type=='process'">选择</el-button>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程激活前置：" v-show="type=='process'">
            <el-input  v-model="form.process_activate_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_activate_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_activate_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.process_activate_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_activate_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_activate_post')" v-show="type=='process'">选择</el-button>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程终止前置：" v-show="type=='process'">
            <el-input  v-model="form.process_terminate_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_terminate_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_terminate_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.process_terminate_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_terminate_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_terminate_post')" v-show="type=='process'">选择</el-button>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="流程删除前置：" v-show="type=='process'">
            <el-input  v-model="form.process_deleted_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_deleted_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_deleted_pre')" v-show="type=='process'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='process'">
            <el-input  v-model="form.process_deleted_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_deleted_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_deleted_post')" v-show="type=='process'">选择</el-button>
          <el-tooltip placement="top" style="width:10%" v-show="type=='process'">
            <div slot="content">
               流程删除上下文参数：<br/>
                   isLastBatch：是否最后一个批次流程 true-是 false-否<br/>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-col>
      </el-row>
      <!-- 不满足分发个人的，所以注释掉，使用后台配置的
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务创建后：" v-show="type=='process'">
            <el-input  v-model="form.process_task_create_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.process_task_create_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('process_task_create_post')" v-show="type=='process'">选择</el-button>
          <el-tooltip placement="top" style="width:10%" v-show="type=='process'">
            <div slot="content">
              所有环节的任务创建后都会调用：<br/>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-col>
      </el-row>
      -->
      <el-row>
        <el-col :span="21">
          <el-form-item label="流向跳转前置：" v-show="type=='line'">
            <el-input v-model="form.flow_sequence_taken_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.flow_sequence_taken_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="showFlowScript('flow_sequence_taken_pre')" v-show="type=='line'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="21">
          <el-form-item label="流向跳转后置：" v-show="type=='line'">
            <el-input v-model="form.flow_sequence_taken_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.flow_sequence_taken_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="showFlowScript('flow_sequence_taken_post')" v-show="type=='line'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务创建后：" v-show="type=='node'">
            <el-input v-model="form.task_create_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_create_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_create_post')" v-show="type=='node'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="任务办理前：" v-show="type=='node'">
            <el-input v-model="form.task_check_before_handle_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_check_before_handle_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_check_before_handle_pre')" v-show="type=='node'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务签收前置：" v-show="type=='node'">
            <el-input v-model="form.task_assignee_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_assignee_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_assignee_pre')" v-show="type=='node'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='node'">
            <el-input v-model="form.task_assignee_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_assignee_postAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_assignee_post')" v-show="type=='node'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务完成前置：" v-show="type=='node'">
            <el-input v-model="form.task_complete_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_complete_preAction"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_complete_pre')" v-show="type=='node'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='node'">
            <el-input v-model="form.task_complete_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_complete_postAction" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_complete_post')" v-show="type=='node'">选择</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务取回前置：" v-show="type=='node'">
            <el-input v-model="form.task_taken_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_taken_preAction" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_taken_pre')" v-show="type=='node'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='node'">
            <el-input v-model="form.task_taken_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_taken_postAction" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_taken_post')" v-show="type=='node'">选择</el-button>
          <el-tooltip placement="top" style="width:10%" v-show="type=='node'">
            <div slot="content">
              任务取回上下文参数：<br/>
              isRollback：是否流程回滚 true-是 false-否<br/>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="任务退回前置：" v-show="type=='node'">
            <el-input v-model="form.task_reject_preName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_reject_preAction" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_reject_pre')" v-show="type=='node'">选择</el-button>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后置：" v-show="type=='node'">
            <el-input v-model="form.task_reject_postName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item  v-show="false">
            <el-input v-model="form.task_reject_postAction" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showFlowScript('task_reject_post')" v-show="type=='node'">选择</el-button>
          <el-tooltip placement="top" style="width:10%" v-show="type=='node'">
            <div slot="content">
              任务退回上下文参数：<br/>
              isRejectToSend：是否退回运转发送任务 true-是 false-否<br/>
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-col>
      </el-row>
    </el-form>
  </mw-dialog>
  <mw-dialog ref="helpDialog" size="small_large" title="帮助说明">
    <div class="mw-toolbar__body">
      <pre><b>SYSTEM：ComponentSystem对象</b>
         SYSTEM.getService(xxx.class):获取Service接口
        </pre>
      <pre><b>RT：ServiceRuntime对象</b>
         RT.invoke(String serviceId, String method, Object... args):调用后台服务接口
        </pre>
      <pre><b>BIT：流程拦截器工具类</b>
         BIT.getConfig()：获取流程、节点、流向配置数据
                           流程脚本则可以获取到流程配置数据；
                           节点脚本则可以获取节点配置数据；
         BIT.getCliParams()：客户端传入的参数
         BIT.getCliLoginUser()：客户端当前登录用户
         BIT.getDatabase()：客户端传入的数据库
         BIT.getFormData()：获取表单数据
         BIT.getModuleId()：获取模块ID
         BIT.getBusinessId()：获取文档ID，注意：表单创建前拦截值为空, 切换节点表单保存前为空
         BIT.getDraftsDocId()：获取文档ID，注意：表单创建前拦截值为空
         BIT.getBatchId()：获取流程批次ID，流程启动前拦截值为空
         BIT.getFormDatabase()：获取表单数据库
         BIT.getFormEntityKey()：获取表单key
         BIT.getTaskData()：节点脚本可获取任务数据

         BIT.getContextParameterNames()：获取上下文所有参数名集合
         BIT.getContext(String name)：获取上下文某个参数的值
         BIT.getApiContextParameterNames()：获取API上下文所有参数名集合
         BIT.getApiContextParameter(String key)：获取API上下文某个参数的值

         BIT.setFormData(Map data)：修改表单数据
         BIT.setProcessUpdateData(Map data)：修改流程数据
        </pre>
      <pre><b>BTT：流程事务工具类</b>
        createForm(Map formData,
                   String moduleId,
                   String formEntityKey,
                   String formEntityId,
                   Integer formEntityVersion,
                   String formDatabase)：创建Form对象
        getForm(String id, String formEntityKey, String formDatabase)：获取Form对象
        removeForm(String id, String formEntityKey, String formDatabase)：删除Form对象
        removeUrge(String businessId, String urgedUserId)：删除催办(注意：不再提供支持，已标记为弃用状态)
        removeUrge(String dataId, String dataType, String urgedUserId)：删除催办
        -----------------------------------------------------
        Form：表数据对象
                getEntity()：获取FormEntity对象
                setData(Map data)：修改表单数据
                addAddReaders(Set addReaders)：新增读者域
                addRemoveReaders(Set removeReaders)：移除读者域
                addCoverReaders(Set coverReaders)：覆盖读者域
                addAddAuthors(Set addAuthors)：新增作者域
                addRemoveAuthors(Set removeAuthors)：移除作者域
                addCoverAuthors(Set coverAuthors)：覆盖作者域
                setFileCopySource(String businessId, String formKey, String database, String[] fileIds)：拷贝某一份文档的附件,fileIds限定拷贝附件ID集合,若为空则拷贝所有附件
        FormEntity：表数据实体对象
                getProperty(String name)：获取属性值
                setProperty(String name, Object value)：修改属性值
                removeProperty(String name)：删除属性值
                getData()：获取表单原数据，Map格式
        </pre>
    </div>
  </mw-dialog>
  </div>
</template>
<script>

  export default {
    props: {
      params: {
        type: Object
      }
    },
    data() {
      let me = this;
      return {
        title: '设置脚本',
        size:'small_small',
        type:'',
        scriptActions:{},
        form: {
          form_create_preName:'',
          form_create_preAction:'',
          form_create_postName:'',
          form_create_postAction:'',
          form_save_preName:'',
          form_save_preAction:'',
          form_save_postName:'',
          form_save_postAction:'',
          process_start_preName:'',
          process_start_preAction:'',
          process_start_postName:'',
          process_start_postAction:'',
          process_done_preName:'',
          process_done_preAction:'',
          process_done_postName:'',
          process_done_postAction:'',
          process_suspend_preName:'',
          process_suspend_preAction:'',
          process_suspend_postName:'',
          process_suspend_postAction:'',
          process_activate_preName:'',
          process_activate_preAction:'',
          process_activate_postName:'',
          process_activate_postAction:'',
          process_terminate_preName:'',
          process_terminate_preAction:'',
          process_terminate_postName:'',
          process_terminate_postAction:'',
          process_deleted_preName:'',
          process_deleted_preAction:'',
          process_deleted_postName:'',
          process_deleted_postAction:'',
          flow_sequence_taken_preName:'',
          flow_sequence_taken_preAction:'',
          flow_sequence_taken_postName:'',
          flow_sequence_taken_postAction:'',
          task_create_postName:'',
          task_create_postAction:'',
          process_task_create_postName:'',
          process_task_create_postAction:'',
          task_check_before_handle_preName:'',
          task_check_before_handle_preAction:'',
          task_assignee_postName:'',
          task_assignee_postAction:'',
          task_assignee_preName:'',
          task_assignee_preAction:'',
          task_complete_postName:'',
          task_complete_postAction:'',
          task_complete_preName:'',
          task_complete_preAction:'',
          task_taken_postName:'',
          task_taken_postAction:'',
          task_taken_preName:'',
          task_taken_preAction:'',
          task_reject_postName:'',
          task_reject_postAction:'',
          task_reject_preName:'',
          task_reject_preAction:''
        },
        scripts1:[],
        footerButton: [
          {
            label: "帮助",
            type: "info",
            func: me.helpnotes
          },
          {
            label: "关闭",
            type: "default",
            func: me.close
          },
          {
            label: "确定",
            func: me.submit
          }
        ]
      }
    },
    mounted() {
      var me = this;
      setTimeout(function(){
        me.show();
      }, 200);
      me.resetForm();
      me.type = me.params.type;
      me.size = me.params.size?me.params.size:'small_small';
      var scriptActions = me.params.scriptActions;
      if(scriptActions){
        for(var k in scriptActions){
            var v = scriptActions[k];
            if(v) {
              me.form[k + 'Name'] = v.name;
              me.form[k + 'Action'] = v.action;
            }
        }
        me.scriptActions = scriptActions;
      }else{
        me.scriptActions = {};
      }
    },
    methods: {
      setBtnLoading(loading, idx){
        this.footerButton[idx].loading = loading;
      },
      btnDebounce: _.debounce(function (callback) {
        let me = this;
        if (callback) {
          callback();
        }
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      submit(){
        let me = this;
        this.mwRef("secrecordForm").validate(valid => {
          if (!valid) {
            return false;
          }
          me.btnDebounce(function () {
            me.setBtnLoading(true, 1);
            me.formActionComplete(me.scriptActions);
            me.setBtnLoading(false, 1);
          });
        });
      },
      formActionComplete(p){
        let me = this;
        if (me.params.func) {
          me.params.func(p)
        }
        me.close();
      },
      showFlowScript(factionType){
        var me  = this;
        var checkValues =[];
        var faction = factionType+'Action';
        var fname = factionType+'Name';
        var actionsSel = me.form[faction];
        var namesSel = me.form[fname];
        if(actionsSel){
          var sAction = actionsSel.split(',');
          var sName = namesSel.split(',');
          let idx=0;
          sAction.forEach(v=>{
            checkValues.push({action:v, name:sName[idx]});
            idx++;
          })
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"),treeDefaultParams: {type: "系统分类/规则",flag:0,languageType:1}
          ,size: 'large_large',
          defaultPercent:25,selectTag:"action",
          selectDefaultPercent:65,
          selectFirst: true,tableSelectData:checkValues,asyncLoadOnce:true,showSelected:true,clearBtn: true, title: '选择规则脚本', changed: function (data) {
            let me = this;
            me.defaultParams = {type: data.code, flag:0,languageType:1};
          }, api: 'app.getAllButton',
          columns:[{type: 'selection'},
          {prop: 'name',label: '名称',tooltip: true},{prop: 'remark',label: '备注',tooltip: true}]
        }, function (res) {
          let actions=[];
          let names = [];
          if (res && res.length > 0) {
            res.forEach(v=>{
              actions.push(v.action);
              names.push(v.name);
            })
          }
          var joinAction = actions.join(',');
          var joinName = names.join(',');
          me.form[faction] = joinAction;
          me.form[fname] = joinName;
          me.scriptActions[factionType]={action:joinAction, name:joinName};
        });
      },
      show(){
        var me = this;
        me.mwRef('dialog').show();
      },
      close(){
        var me = this;
        me.resetForm();
        me.mwRef('dialog').hide();
      },
      resetForm(){
        var me = this;
        me.form.form_create_preName='';
        me.form.form_create_preAction='';
        me.form.form_create_postName='';
        me.form.form_create_postAction='';
        me.form.form_save_preName='';
        me.form.form_save_preAction='';
        me.form.form_save_postName='';
        me.form.form_save_postAction='';
        me.form.process_start_preName='';
        me.form.process_start_preAction='';
        me.form.process_start_postName='';
        me.form.process_start_postAction='';
        me.form.process_done_preName='';
        me.form.process_done_preAction='';
        me.form.process_done_postName='';
        me.form.process_done_postAction='';
        me.form.process_suspend_preName='';
        me.form.process_suspend_preAction='';
        me.form.process_suspend_postName='';
        me.form.process_suspend_postAction='';
        me.form.process_activate_preName='';
        me.form.process_activate_preAction='';
        me.form.process_activate_postName='';
        me.form.process_activate_postAction='';
        me.form.process_terminate_preName='';
        me.form.process_terminate_preAction='';
        me.form.process_terminate_postName='';
        me.form.process_terminate_postAction='';
        me.form.process_deleted_preName='';
        me.form.process_deleted_preAction='';
        me.form.process_deleted_postName='';
        me.form.process_deleted_postAction='';
        me.form.flow_sequence_taken_preName='';
        me.form.flow_sequence_taken_preAction='';
        me.form.flow_sequence_taken_postName='';
        me.form.flow_sequence_taken_postAction='';
        me.form.task_create_postName='';
        me.form.task_create_postAction='';
        me.form.task_check_before_handle_preName='';
        me.form.task_check_before_handle_preAction='';
        me.form.task_assignee_preName='';
        me.form.task_assignee_preAction='';
        me.form.task_assignee_postName='';
        me.form.task_assignee_postAction='';
        me.form.task_complete_preName='';
        me.form.task_complete_preAction='';
        me.form.task_complete_postName='';
        me.form.task_complete_postAction='';
        me.form.task_taken_preName='';
        me.form.task_taken_preAction='';
        me.form.task_taken_postName='';
        me.form.task_taken_postAction='';
        me.form.task_reject_preName='';
        me.form.task_reject_preAction='';
        me.form.task_reject_postName='';
        me.form.task_reject_postAction='';

        me.type='';
        me.size='small_small';
        me.scriptActions={};
      },
      helpnotes(){
        var me = this;
        me.mwRef('helpDialog').show();
      }
    }
  }
</script>
<style>
  .flow-script-set .el-button {
    padding: 7px 12px;
  }
</style>




// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/flow-script-set.vue